var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9242 4.48737H6.71156C4.98425 4.48737 3.58398 5.88758 3.58398 7.61484V18.0398C3.58398 19.7671 4.98425 21.1673 6.71156 21.1673H17.1368C18.8641 21.1673 20.2644 19.7671 20.2644 18.0398L20.2644 12.8273M8.7966 15.9548L12.5896 15.1905C12.791 15.1499 12.9759 15.0508 13.1211 14.9055L21.6122 6.41005C22.0193 6.00274 22.019 5.3425 21.6116 4.93553L19.8128 3.13891C19.4056 2.7321 18.7456 2.73238 18.3387 3.13953L9.84674 11.6359C9.70182 11.7809 9.60286 11.9654 9.56225 12.1663L8.7966 15.9548Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.8a359ce0132f5c664a89f716f1d2eb1f.svg";
export { ForwardRef as ReactComponent };